import React, { useEffect, useState } from 'react'
import Wrapper from '../../helpers/Wrapper'
import SectionHead from '../SectionHead'
import Product from '../Product/Product'
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../helpers/Axios';
import ProductSke from '../Skeletons/ProductSke';

function PopularProducts() {


    const [products, setProducts] = useState([])

    const { data, isPending } = useQuery({
        queryKey: ['popular'],
        queryFn: async () => {
            const res = await apiClient.get('/product/popular')
            return res.data?.data
        }
    })

    useEffect(() => { setProducts(data || []) }, [data])


    if (isPending) {
        return (
            <Wrapper>
                <div className="grid grid-cols-2 mt-8 gap-3 sm:gap-9 lg:grid-cols-4 xl:grid-cols-4">
                    <ProductSke />
                    <ProductSke />
                    <ProductSke />
                    <ProductSke />
                    <ProductSke />
                    <ProductSke />
                    <ProductSke />
                    <ProductSke />
                </div>
            </Wrapper>
        )
    }


    return (
        <div className='w-full relatives'>
            <Wrapper>
                <SectionHead
                    title={"Popular Products"}
                    description={"Discover the latest eco-friendly products in our New Arrivals collection."}
                />

                {/* Products */}
                <div className="grid grid-cols-2 mt-8 gap-3 sm:gap-9 lg:grid-cols-4 xl:grid-cols-4">
                    {
                        products.map((product, i) => (
                            <div key={i}>
                                <Product data={product} loading={isPending} />
                            </div>
                        ))
                    }
                </div>
            </Wrapper>
        </div>
    )
}

export default PopularProducts